export default {
  'business-growth': 'Faça o seu negócio crescer',
}
